// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { difference, includes } from 'lodash';

// Services
import { refreshIfModified } from '../../element/board/boardService';

// Selectors
import socketChannelSelector from './socketChannelSelector';
import { getFetchedBoardIds } from '../../element/board/boardSelector';

const mapStateToProps = createSelector(
    socketChannelSelector,
    getFetchedBoardIds,
    ({ boardChannels }, fetchedBoardIds) => ({
        boardChannels,
        fetchedBoardIds,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchRefreshIfModified: (boardId) => dispatch(refreshIfModified({ boardId })),
});

@connect(mapStateToProps, mapDispatchToProps)
class RefreshStaleBoardManager extends React.Component {
    componentWillReceiveProps(nextProps) {
        const { dispatchRefreshIfModified, boardChannels, fetchedBoardIds } = nextProps;

        if (boardChannels !== this.props.boardChannels) {
            const newBoardChannels = difference(boardChannels, this.props.boardChannels);
            newBoardChannels.forEach((boardId) => {
                // Haven't retrieved the board yet so no need checking if it's been modified
                if (!includes(fetchedBoardIds, boardId)) return;

                dispatchRefreshIfModified(boardId);
            });
        }
    }

    render() {
        return null;
    }
}

RefreshStaleBoardManager.propTypes = {
    boardChannels: PropTypes.array,
    fetchedBoardIds: PropTypes.array,
    dispatchRefreshIfModified: PropTypes.func,
};

export default RefreshStaleBoardManager;
